






























































































































































































































































































































































































































































































import {
  toRefs,
  ref,
  reactive,
  computed,
  defineComponent
} from "@vue/composition-api";
import { Report, Area, Zone, Location } from "@/interfaces/interfaces";
import { useMainStore } from "@/store/storage";
import { db } from "@/firebase/firebase";
import ReportForm from "@/views/reports/ReportForm.vue";
import ReportTable from "@/views/reports/ReportTable.vue";
import ReportPage from "@/views/reports/ReportPage.vue";

// import _ from "lodash";

export default defineComponent({
  name: "ReportDashboard",
  components: {
    ReportForm,
    ReportTable,
    ReportPage
  },
  props: {
    pages: {
      type: String
    }
  },

  setup(props, { root }) {
    const main = useMainStore();

    const form = (ref(null) as unknown) as HTMLFormElement;
    const state = reactive({
      area: "",
      page: root.$route.params.page,
      valid: false,
      showUploader: false,
      showmessage: false,
      showProgress: false,
      dialog: false,
      message: "",
      messageClass: "success",
      inspectionAreas: [] as Area[],
      projectName: "projectOne",
      projectSurvey: [] as Report[],
      id: "",
      photo: "",
      inspectionArea: "",
      inspectionZone: "",
      inspectionLocation: "",
      primarySecuring: "",
      secondaryRetention: "",
      howToInspect: "",
      condition: "Pass",
      comments: "",
      control: "",
      reference: "",
      active: {
        area: null,
        zone: null,
        action: null
      }
    });

    // const formData = reactive({
    //   id: "",
    //   photo: "",
    //   inspectionArea: "",
    //   inspectionZone: "",
    //   description: "",
    //   inspectionLocation: "",
    //   primarySecuring: "",
    //   secondaryRetention: "",
    //   howToInspect: "",
    //   condition: "Pass",
    //   comments: "",
    //   control: "",
    //   reference: ""
    // }) as Report;

    state.projectSurvey = main.state.projectSurvey;

    const areaSelect = computed(() => {
      return main.state.inspectionAreas.map((e: Area) => e.area);
    });
    const zoneSelect = computed(() => {
      return main.state.inspectionZones.map((e: Zone) => e.zone);
    });
    const locationSelect = computed(() => {
      return main.state.locations.map((e: Location) => e.location);
    });
    const mobile = computed(() => {
      return root.$vuetify.breakpoint.mobile;
    });
    const mdAndUp = computed(() => {
      return root.$vuetify.breakpoint.mdAndUp;
    });
    const theme = computed(() => {
      const route = root.$route.params.page;
      const theme = {
        color: "info",
        title: "Reports"
      };

      switch (route) {
        case "passed":
          theme.color = "success";
          theme.title = "Passed";
          break;
        case "failed":
          theme.color = "error";
          theme.title = "DO Failed Items List";
          break;
        case "none":
        case "":
          theme.color = "warning";
          theme.title = "Not Set";
          break;

        default:
          theme.color = "info";
          theme.title = "All Records";
          break;
      }
      return theme;
    });

    function conditionCheck(item: Report) {
      const route = root.$route.params.page;
      // console.log(route, item.condition);
      if (route === undefined) return true;
      if (route == "failed" && item.condition == "Fail") return true;
      if (route == "passed" && item.condition == "Pass") return true;
      if (
        route == "none" &&
        (item.condition == "None" ||
          item.condition == "" ||
          item.condition === undefined)
      )
        return true;
      return false;
    }

    function order(
      collection: Zone[],
      field: Array<never>,
      direction: Array<never>
    ): Array<Zone> {
      return root.lodash.orderBy(collection, field, direction);
    }

    if (main.state.projectData.id) {
      db.collection("projects")
        .doc(main.state.projectData.id as string)
        .collection("reports")

        .orderBy("inspectionArea")
        //   .orderBy("inspectionZone")
        //   .orderBy("Location")
        //   .orderBy("Reference")
        .onSnapshot((snapshot) => {
          const records = [] as Report[];
          snapshot.forEach((item) => {
            records.push({ id: item.id, ...item.data() } as Report);
          });
          state.projectSurvey = records;
        });
    }

    // function getAreas() {
    // // //   console.log("HEY PINIA");

    // }

    // getAreas();

    // // // console.log("MAIN", main.state.inspectionAreas);

    function hideMessage() {
      setTimeout(() => {
        state.showmessage = false;
        state.showProgress = false;
      }, 3000);
    }

    function saveArea() {
      if (state.valid) {
        const order = new Date().valueOf();
        const data = {
          order,
          area: state.area
        };
        if (state.area) {
          state.valid = false;
          state.showProgress = true;
          db.collection("InspectionAreas")
            .add(data)
            .then(() => {
              console.log(state.page, state.area, order);
              state.showmessage = true;
              state.showProgress = false;
              state.message = "Area name successfull saved";
              state.messageClass = "success";
              //@ts-ignore
              form.value.reset();
              //@ts-ignore
              form.value.resetValidation();

              hideMessage();
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          // alert("Provide Area");
          state.showmessage = true;
          state.showProgress = false;
          state.message = "Something was wrong with the Area name";
          state.messageClass = "error";
          hideMessage();
        }
      }
    }

    // interface Report {
    //   id?: string;
    //   photo?: string;
    //   inspectionArea: string;
    //   inspectionZone: string;
    //   inspectionLocation: string;
    //   primarySecuring: string;
    //   secondaryRetention: string;
    //   howToInspect: string;
    //   condition: string;
    //   comments: string;
    //   control: string;
    //   reference: string;
    // }

    function clearItem() {
      state.id = "";
      state.inspectionArea = "";
      state.inspectionZone = "";
      state.inspectionLocation = "";
      state.primarySecuring = "";
      state.secondaryRetention = "";
      state.howToInspect = "";
      state.condition = "Pass";
      state.comments = "";
      state.control = "";
      state.reference = "";

      form.value.reset();
      form.value.resetValidation();

      console.log(state.id);
    }

    function addItem() {
      clearItem();
      state.dialog = true;
    }

    function setItem(e: Report): void {
      state.id = e.id as string;
      state.inspectionArea = e.inspectionArea;
      state.inspectionZone = e.inspectionZone;
      state.inspectionLocation = e.inspectionLocation;
      state.primarySecuring = e.primarySecuring || "";
      state.secondaryRetention = e.secondaryRetention || "";
      state.howToInspect = e.howToInspect || "";
      state.condition = e.condition || "Pass";
      state.comments = e.comments || "";
      state.control = e.control || "";
      state.reference = e.reference;
      state.photo = e.photo as string;
      state.dialog = true;
      console.log(e, state.id);
    }

    function saveItem(): void {
      if (state.id && state.id.length > 4) {
        const data = {
          inspectionArea: state.inspectionArea,
          inspectionZone: state.inspectionZone,
          inspectionLocation: state.inspectionLocation,
          primarySecuring: state.primarySecuring,
          secondaryRetention: state.secondaryRetention,
          howToInspect: state.howToInspect,
          condition: state.condition,
          comments: state.comments,
          control: state.control,
          reference: state.reference,
          photo: state.photo
        };

        // console.log(data);

        if (main.state.projectData.id) {
          db.collection("projects")
            .doc(main.state.projectData.id as string)
            .collection("reports")
            .doc(state.id)
            .update(data)
            .then((id) => {
              console.log("completed", id);
              state.dialog = false;
            });
        }
      }
    }

    console.log(state.projectSurvey);

    // function doFind(obj: object, area: string) {
    //   // const ju = root.lodash.find({ ...obj }, { id: area } as never) as object;
    //   // console.log("@@", ju, typeof ju);
    //   // return ju || {};
    //   // return yu;
    // }

    const countReports = computed(() => {
      const len = main.state.reports.length;
      return len;
    });

    return {
      mainState: main.state,
      mainStore: main,
      ...toRefs(state),
      saveArea,
      form,
      setItem,
      addItem,
      clearItem,
      saveItem,
      areaSelect,
      locationSelect,
      zoneSelect,
      conditionCheck,
      mobile,
      mdAndUp,
      countReports,
      order,
      theme
    };
  }
});
